import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useFormikContext, Field } from 'formik';
import { Textarea } from '../../Textarea/component.js';
var _excluded = ["customValidityMessage", "validators", "label", "onChange", "changeHandler"];
var TextareaField = function TextareaField(_ref) {
  _ref.customValidityMessage;
  _ref.validators;
  _ref.label;
  var onChange = _ref.onChange,
    changeHandler = _ref.changeHandler,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!useFormikContext()) {
    throw Error('The <TextareaField /> component must be wrapped in a Formik context.  Did you mean to use the Core.Textarea instead?');
  }
  var setField = function setField(event) {
    onChange === null || onChange === undefined || onChange(event);
    changeHandler === null || changeHandler === undefined || changeHandler(event);
  };
  return /*#__PURE__*/React.createElement(Field, _extends({
    as: Textarea
  }, rest, {
    onChange: function onChange(event) {
      return setField(event);
    }
  }));
};
TextareaField.displayName = "TextareaField";
export { TextareaField };